/**
 * Role-related translations for Portuguese language
 * This file contains translations for role names and descriptions
 */
export default {
  roles: {
    merlin: 'Merlin',
    merlinPure: 'Merlin Puro',
    guinevere: 'Guinevere',
    percival: 'Percival',
    tristan: 'Tristan',
    isolde: 'Isolde',
    troublemaker: 'Encrenqueiro',
    servant: 'Servo',
    goodLancelot: 'Lancelot Bom',
    evilLancelot: 'Lancelot Mau',
    lancelots: 'Lancelots',
    mordred: 'Mordred',
    trickster: 'Trapaceiro',
    morgana: 'Morgana',
    oberon: 'Oberon',
    lunatic: 'Lunático',
    brute: 'Bruto',
    minion: 'Lacaio',
    witch: 'Bruxa',
    cleric: 'Clérigo',
    revealer: 'Revelador',
    role: 'Papel',
    unknown: 'Papel desconhecido',
    mysteryWizard: 'Mago misterioso',
    unknownLancelot: 'Lancelot desconhecido',
    wraith: 'Espectro',
  },
  rolesInfo: {
    roles: 'Papéis',
    inGameRoles: 'Papéis no jogo',
    visibleRoles: 'Papéis visíveis para você',
    merlinInfo: 'Conhece o mal, deve permanecer oculto',
    merlinPureInfo: 'Conhece o mal e seus papéis, deve permanecer oculto',
    percivalInfo: 'Conhece dois magos (Merlin e Morgana), mas não sabe qual é qual',
    servantInfo: 'Servo Leal de Arthur',
    troublemakerInfo: 'Obrigado a mentir sobre sua lealdade',
    guinevereInfo: 'Conhece dois Lancelots mas não conhece sua lealdade',
    goodLancelotInfo: 'Lancelot bom, pode mudar para o mal durante o jogo',
    evilLancelotInfo: 'Lancelot mau, pode mudar para o bem durante o jogo',
    mordredInfo: 'Desconhecido para Merlin',
    morganaInfo: 'Aparece como Merlin para Percival',
    oberonInfo: 'Desconhecido para o Mal',
    minionInfo: 'Lacaio de Mordred',
    isoldeInfo: 'Amante. Conhece Tristan, deve permanecer oculto',
    tristanInfo: 'Amante. Conhece Isolde, deve permanecer oculto',
    evilInfo: 'Jogador do mal com papel desconhecido',
    goodInfo: 'Jogador do bem com papel desconhecido',
    tricksterInfo: 'Mentindo sobre sua lealdade',
    lunaticInfo: 'Deve falhar em todas as missões',
    bruteInfo: 'Pode falhar apenas nas três primeiras missões',
    witchInfo:
      'Pode ocultar o resultado de uma missão, mas isso dará uma verificação de lealdade a um jogador aleatório',
    revealerInfo: 'Revela-se após a segunda missão falha',
    clericInfo: 'Conhece a lealdade do líder da primeira missão. Deve permanecer oculto',
    unknownInfo: 'Papel desconhecido',
    mysteryWizardInfo: 'Um dos dois magos é bom (Merlin) ou mau (Morgana)',
    unknownLancelotInfo: 'Lancelot, cuja lealdade não é conhecida',
    wraithInfo: 'Desconhecido para o Mal e Merlin',
  },
};
